import React, { Component } from 'react';
import moment from "moment";
import './index.less';

export default class CardBody extends Component {
    render() {
        const { vbilltypecode, dbilldate, deliveryBodys, type, fstatusflag } = this.props;
        let date = moment(new Date(dbilldate?.replace(/\-/g, '/'))).format("YYYY-MM-DD");
        let receiveData = [],
            sendData = [];

        let historyConnect = (
            fstatusflag.code !== 1
                ? <div><div className="history-connect-right">已完成</div><div className="history-connect-img"></div></div>
                : <div><div className="history-connect-cancel">已作废</div><div className="history-connect-img"></div></div>
        )

        let unitListconnect =(
            type === "backlog" 
                ? <div className="backlog-connect"><div className="backlog-connect-img"></div></div>
                : <div className="history-connect">{historyConnect}</div>
        );

        deliveryBodys.forEach(item => {
            receiveData.push(item.receiveUnit?.name);
            sendData.push(item.sendUnit?.name);
        })

        receiveData = [...new Set(receiveData)];
        sendData = [...new Set(sendData)];

        if(receiveData.length > 2){
            receiveData.splice(2);
            receiveData.push("...");
        }

        if(sendData.length > 2){
            sendData.splice(2);
            sendData.push("...");
        }

        let deliveryList = receiveData.map((item,index) => {
            return <div key={index} >{item}</div>
        })

        let sendList = sendData.map((item,index) => {
            return <div key={index} >{item}</div>
        })

        let deliveryGoodsContainer = (
            <div className="delivery-container">
                <div className="delivery-container-unitdate">
                    <div>{sendData[0]}</div>
                    <div className="date-part">
                        <div className="date-icon"></div>
                        <div>{date}</div>
                    </div>
                </div>
                <div>{unitListconnect}</div>
                <div className="delivery-container-unit">{deliveryList}</div>
            </div>
        )

        let sendGoodsContainer = (
            <div className="send-container">
                <div className="send-container-unit">{sendList}</div>
                <div>{unitListconnect}</div>
                <div className="send-container-unitdate">
                    <div>{receiveData[0]}</div>
                    <div className="date-part">
                        <div className="date-icon"></div>
                        <div>{date}</div>
                    </div>
                </div>
            </div>
        )

        return (
            <div className="card-container-body">
                {
                    vbilltypecode === "4EAB"
                        ? <div>{deliveryGoodsContainer}</div>
                        : <div>{sendGoodsContainer}</div>
                }
            </div>
        )
    }
}
